import React, { useEffect, useRef, useState } from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import close from "../../../src/assests/images/Closered.svg";
import gallery from "../../../src/assests/images/gallaryIcon.svg";
import add from "../../../src/assests/images/plusRed.svg";

import { useNavigate, useParams } from "react-router-dom";

interface ImageUploadBoxProps {
  largeimagedata: string | null;
  imageDataValue1: string | null;
  keyvisuallength: any;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>, key: string) => void;
  previews: Record<string, string | null>;
  edit?: number;
  mainimagedata: string;
  setPreviews?: React.Dispatch<React.SetStateAction<Record<string, string | null>>>;
}

const ImageUploadBox: React.FC<ImageUploadBoxProps> = ({
  keyvisuallength,
  handleFileChange,
  previews,
  setPreviews,
  mainimagedata,
}) => {
  const handleRemoveImage = (key: string) => {
    if (!setPreviews) return;

    setPreviews((prev) => ({
      ...prev,
      [key]: null,
    }));
  };

  const renderUploadBox = (
    key: string,
    button?: React.ReactNode,
    imageId?: string
  ) => (
    <Box
      onClick={() =>
        (document.getElementById(`${key}Input`) as HTMLInputElement)?.click()
      }
      sx={{
        borderRadius: "12px",
        background: previews[key] ? "none" : "#FFF",
        border: previews[key] ? "none" : "2px dashed var(--60, #C5C6C7)",
        textAlign: "center",
        cursor: "pointer",
        position: "relative",
        overflow: "hidden",
        width: "100%",
        margin: "16px 0 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "180px",
      }}
    >
      {previews[key] ? (
        <>
          <img
            src={previews[key]!}
            className="img-fluid"
            alt="Uploaded Preview"
            style={{
              maxHeight: "100%",
              height: "245px",
              objectFit: "cover",
              width: "100%",
              borderRadius: "12px",
              backgroundColor: "#FFF",
            }}
            crossOrigin="anonymous"
          />
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              handleRemoveImage(key);
            }}
            sx={{
              position: "absolute",
              top: "5px",
              right: "5px",
              background: "#FFEBEF",
              color: "#000",
              borderRadius: "50%",
              padding: "5px 12px 12px",
              width: "32px",
              height: "32px",

              "&:hover": {
                background: "#FFEBEF",
              },
            }}
          >
            <img src={close} crossOrigin="anonymous" alt="Remove" />
          </IconButton>
        </>
      ) : (
        <Box sx={{ padding: "0 54px" }}>
          {(key === "topPanel" || key.startsWith("keyVisual")) && (
            <img src={gallery} crossOrigin="anonymous" alt="Gallery Icon" />
          )}
          <Typography
            sx={{
              fontSize: key === "topPanel" ? "16px" : "14px",
              fontWeight: key === "topPanel" ? "600" : "500",
              color: key === "topPanel" ? "#696A6B" : "#7D7E7F",
              margin: "8px 0 10px",
            }}
          >
            {key === "topPanel"
              ? "Drag & Drop your Image/Gif here or Choose file"
              : "PNG, JPG, GIF, SVG (Max 5 MB)"}
          </Typography>

          {key === "keyVisual2" && (
            <Button
              sx={{
                borderRadius: "8px",
                border: "1px solid #C8172F",
                padding: "12px 16px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#C8172F",
                textTransform: "unset",
              }}
            >
              <img
                style={{ marginRight: "8px" }}
                crossOrigin="anonymous"
                src={add}
                alt="Add More"
              />
              Add More
            </Button>
          )}

<Typography
              sx={{ fontSize: "14px", fontWeight: "500", color: "#7D7E7F" }}
            ></Typography>
                      {button}
        </Box>
      )}

      <input
        id={`${key}Input`}
        type="file"
        accept="image/png, image/jpeg, image/gif, image/svg+xml"
        style={{ display: "none" }}
        onChange={(e) => handleFileChange(e, key)}
      />

      {button && !previews[key] && (
        <Box sx={{ marginTop: "10px" }}>{button}</Box>
      )}
    </Box>
  );

  return (
    <>
      <Box>
        <Typography variant="h6" sx={{ fontSize: "18px", fontWeight: "600", color: "#282829" }}>
          Top Panel Image
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#696A6B",
            paddingTop: "2px",
          }}
        >
          Upload a pack top panel image to display above the product information
          for retailers.
        </Typography>
        {renderUploadBox("topPanel")}
      </Box>
      <Box>
        <Typography variant="h6" sx={{ fontSize: "18px", fontWeight: "600", color: "#282829" }}>
          Key Visual Images (Optional)
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontSize: "16px",
            fontWeight: "400",
            color: "#696A6B",
            paddingTop: "2px",
          }}
        >
          Upload Key visuals of the pack like front, side, and back view of the
          product.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", gap: "24px" }}>
        {["keyVisual1", "keyVisual2"].map((key) => (
          <Box sx={{ width: "335px" }} key={key}>
            {renderUploadBox(key)}
          </Box>
        ))}
      </Box>
    </>
  );
};

export default ImageUploadBox;